<script lang="ts">
	import { onMount } from 'svelte';
	import type { Article } from '$lib/domain/article.interface';
	import type { Review } from '$lib/domain/review.interface';

	export let item: { article: Article; review: Review | undefined };
	export let reverse: false | true = false;

	const uniqueClassName = item ? item.article.thumbnailImage.replace('.webp', '') : null;

	onMount(() => {
			if (typeof IntersectionObserver === 'undefined') {
					return;
			}

			let observer = new IntersectionObserver(
					(entries, observer) => {
							entries.forEach((entry) => {
									if (!entry.isIntersecting) {
											return;
									}

									const htmlTarget = entry.target as HTMLElement;
									htmlTarget.style.backgroundImage = `url(/articles/${item.article.backgroundImage})`;
									observer.unobserve(htmlTarget);
							});
					},
					{ threshold: 0, rootMargin: '20px' }
			);

			document.querySelectorAll(`.${uniqueClassName}`).forEach((entry) => observer.observe(entry));
	});
</script>

<div class="case-study {uniqueClassName}" class:reverse="{reverse}">
	<div class="case-studies-content flex-column">
		
		{#if item.review.title}
			<h3>{item.review.title}</h3>
			{:else }
			<h3>{item.article.title}</h3>
		{/if}

		<p>{@html item.review?.text || ''}</p>
		
		<p>{item.review?.jobTitle || ''}</p>
		
		<div class="spacer"></div>
		
		<a class="card-action" href="{item.article.url}"> Learn more > </a>
	</div>
</div>

<style lang="scss">
	@import '$styles/vars';

	.case-study {
		display: flex;
		flex-direction: column;
		width: 65%;
		position: relative;
		background-size: cover;
		background-repeat: no-repeat;
		min-height: 525px;
		justify-content: center;
		border-radius: 24px;

		&.reverse {
			background-position: left;
			align-items: flex-end;
			right: 35%;

			.case-studies-content {
				left: 54%;
			}
		}

		.case-studies-content {
			margin: 10% 0;
			position: relative;
			left: -54%;
			border-radius: 24px;
			width: 590px;
			padding: 24px;
			background-color: $light-grey;
			color: $main-black;
			font-size: 14px;
			font-weight: 400;
			white-space: pre-line;
			justify-content: flex-start;
			align-items: flex-start;

			.spacer {
				height: 100%;
			}

			.card-action {
				margin-top: 40px;
				padding-left: 0;
				color: $green;
				font-size: 14px;
				line-height: 22px;
				font-weight: 400;
				text-align: center;

				&:hover {
					text-decoration: underline;
				}
			}
		}
	}

	@media (min-width: $portrait-phone-size) and (max-width: $tablet-size) {
		.case-study {
			background-size: 700px auto !important;
			min-height: 400px;

			.case-studies-content {
				margin-top: 0;
			}
		}
	}

	@media (max-width: $portrait-phone-size) {
		.case-study {
			background-size: 600px auto !important;
			background-position: top !important;

			.case-studies-content {
				width: auto !important;
				margin-left: 16px;
				margin-right: 16px;
			}
		}
	}
</style>
